export type OperationalDetailWindow = '24h' | '7d'
export type OperationalDetailGranularity = '4h' | 'day'

export interface OperationalSeriesPoint {
  label: string
  from: string
  to: string
  count: number
}

export interface OperationalSeries<
  TWindow extends OperationalDetailWindow = OperationalDetailWindow,
  TGranularity extends OperationalDetailGranularity = OperationalDetailGranularity,
> {
  window: TWindow
  granularity: TGranularity
  points: OperationalSeriesPoint[]
}

export interface MiniSparklineContract<
  TWindow extends OperationalDetailWindow = OperationalDetailWindow,
  TGranularity extends OperationalDetailGranularity = OperationalDetailGranularity,
> {
  window: TWindow
  granularity: TGranularity
  pointCount: number
}

export const T1_CRITICALS_SPARKLINE_CONTRACT = {
  window: '24h',
  granularity: '4h',
  pointCount: 6,
} as const satisfies MiniSparklineContract<'24h', '4h'>

export const T6_SUPPLY_CHAIN_SPARKLINE_CONTRACT = {
  window: '7d',
  granularity: 'day',
  pointCount: 7,
} as const satisfies MiniSparklineContract<'7d', 'day'>

export const T2_RANSOM_SPARKLINE_CONTRACT = {
  window: '7d',
  granularity: 'day',
  pointCount: 7,
} as const satisfies MiniSparklineContract<'7d', 'day'>

export type BreakdownTone = 'critical' | 'high' | 'medium' | 'low' | 'neutral'

export interface SegmentedBreakdownSegment {
  label: string
  value: number
  tone?: BreakdownTone
}

export type RangeMeterBand = 'red' | 'amber' | 'green'
export type RangeMeterBandLabel = 'Low' | 'Normal' | 'Elevated' | 'High'

export interface RankStackRow {
  label: string
  value: number | string
  detail?: string
}

export interface AmountCalloutLargest {
  organisation: string
  amountEur: number
}

export interface InfoChip {
  label: string
  detail?: string
  tone?: BreakdownTone
}
